export default "__VITE_ASSET__DNQvZdNh__"